import { render } from "./pms.vue?vue&type=template&id=48952495&scoped=true"
import script from "./pms.vue?vue&type=script&lang=js"
export * from "./pms.vue?vue&type=script&lang=js"

import "./pms.vue?vue&type=style&index=0&id=48952495&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48952495"]])

export default __exports__